import React from 'react';
import { reaction } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { css } from 'styled-components';

import { Stack, Box } from 'grommet';
import { AddCircle, SubtractCircle, More, Revert } from 'grommet-icons';

import AppState from 'app/state/AppState';
import Button from 'app/components/Button';

let hasInsertedBookmark = false;
let hasDeletedBookmark = false;
let amountOfBookmarks;
reaction(
  () => AppState.bookmarks.collection.length,
  newAmountOfBookmarks => {
    if (!amountOfBookmarks) {
      amountOfBookmarks = newAmountOfBookmarks;
      return;
    }
    if (newAmountOfBookmarks > amountOfBookmarks) {
      hasInsertedBookmark = true;
    } else {
      hasDeletedBookmark = true;
    }
    amountOfBookmarks = newAmountOfBookmarks;
  }
);

function showAnimation() {
  let shouldAnimate = hasInsertedBookmark || hasDeletedBookmark;
  return shouldAnimate;
}

function showDeleteIcon() {
  let shouldShow = hasDeletedBookmark;
  hasDeletedBookmark = false;
  return shouldShow;
}

function showInsertIcon() {
  let shouldShow = hasInsertedBookmark;
  hasInsertedBookmark = false;
  return shouldShow;
}

const icon = icon => styled(icon)`
  ${props => props.indicator && css`
    width: 30px;
    height: 30px;
    transform: translateX(15px);
  `}
  ${props => props.button && css`
    width: 48px;
    height: 48px;
  `}
  @media (max-width: 600px) {
    ${props => props.indicator && css`
      transform: translate(16px, -5px);
    `}
    ${props => props.button && css`
      width: 24px;
      height: 24px;
    `}
  }
`;

const ShowBookmarks = icon(More);
const ReturnButton = icon(Revert);
const InsertBookmark = icon(AddCircle);
const DeleteBookmark = icon(SubtractCircle);

function BookmarksButton({ AppState }) {
  const { isBookmarksMenuOpen: isOpen } = AppState;
  return (
    <Button
      direction="row"
      pad="small"
      justify="center"
      align="center"
      fill="vertical"
      onClick={() => AppState.toggleBookmarksMenu()}
    >
      <Stack anchor="top-right">
        {!isOpen && <ShowBookmarks button={1} color="accent-1" />}
        {isOpen && <ReturnButton button={1} color="accent-1" />}
        {showAnimation() && (
          <Box
            animation={[
              {
                type: 'fadeOut',
                delay: 1200,
                duration: 2400,
                size: 'xlarge',
              },
              {
                type: 'slideDown',
                duration: 600,
                size: 'xlarge',
              },
            ]}
          >
            {showInsertIcon() && (
              <InsertBookmark indicator="true" color="accent-2" />
            )}
            {showDeleteIcon() && (
              <DeleteBookmark indicator="true" color="status-critical" />
            )}
          </Box>
        )}
      </Stack>
    </Button>
  );
}

export default inject('AppState')(observer(BookmarksButton));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/BookmarksButton.js